/**
 * Formats a given phone number string into a standard display format.
 *
 * The function performs the following steps:
 * 1. Removes all non-digit characters from the input string.
 * 2. Limits the resulting string to a maximum of 10 digits.
 * 3. Formats the digits into one of the following formats based on the number of digits:
 *    - (555) 123-4567
 *    - (555) 123
 *    - (555
 *
 * @param phone - The phone number string to be formatted.
 * @returns The formatted phone number string.
 */
export const formatPhone = (phone: string) => {
	// Keep only digits
	const digits = phone.replace(/\D/g, '').slice(0, 10);

	// Format for display
	const formatted = digits.replace(
		/^(\d{0,3})(\d{0,3})(\d{0,4})$/,
		(_, areaCode, prefix, lineNumber) => {
			// If we have all 3 parts, format as: (555) 123-4567
			if (lineNumber) return `(${areaCode}) ${prefix}-${lineNumber}`;
			// If we have area code and prefix, format as: (555) 123
			if (prefix) return `(${areaCode}) ${prefix}`;
			// If we only have area code, format as: (555
			if (areaCode) return `(${areaCode}`;
			// If no digits entered yet, return empty string
			return '';
		},
	);

	return formatted;
};
